import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { BsChatDots, BsRobot, BsPeopleFill, BsHouseDoor } from 'react-icons/bs';

const HowItWorks: React.FC = () => {
  const steps = [
    {
      icon: <BsChatDots size={40} />,
      title: "Tell Us Your Needs",
      description: "Describe your dream home in natural language - budget, location, must-haves"
    },
    {
      icon: <BsRobot size={40} />,
      title: "AI Finds Perfect Matches",
      description: "Our AI analyzes thousands of listings to find properties that match your criteria"
    },
    {
      icon: <BsPeopleFill size={40} />,
      title: "Connect with Top Agents",
      description: "Get matched with experienced agents who specialize in your area and needs"
    },
    {
      icon: <BsHouseDoor size={40} />,
      title: "Find Your Home",
      description: "Tour properties, make offers, and close with confidence"
    }
  ];

  return (
    <div className="how-it-works-section">
      <h2 className="section-title">How Chat.RealEstate Works</h2>
      <p className="section-subtitle">
        A smarter way to find your next home
      </p>
      
      <Row className="steps-row">
        {steps.map((step, idx) => (
          <Col key={idx} md={3} sm={6} className="mb-4">
            <Card className="step-card h-100">
              <Card.Body className="text-center">
                <div className="step-number">{idx + 1}</div>
                <div className="step-icon">{step.icon}</div>
                <h4 className="step-title">{step.title}</h4>
                <p className="step-description">{step.description}</p>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default HowItWorks;